var isBrowser = typeof window !== 'undefined';

export { isBrowser };
